import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
// import { useDispatch } from "react-redux";
import { Form, Button, Card, Space } from "antd";
import { toast } from "react-toastify";
import FormFields from "./FormFields";
import { useDispatch, useSelector } from "react-redux";
import { addPerson } from "../../../redux/slices/persons/personsThunk";
import { getGovernments } from "../../../redux/slices/governments/governmentsThunk";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const AddGrossistesPage = () => {
  const person_loading = useSelector((state) => state.persons.loading);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const history = useHistory();

  const onFinish = (values) => {
    const formattedValues = {
      firstname: values.firstname,
      lastname: values.lastname,
      wholesaler: {
        companyName: values.companyName,
      },
      email: values.email,
      phoneNumber: values.phoneNumber,
      address: values.address,
      region: { id: values.region },
      government: { id: values.government },
    };
    dispatch(addPerson(formattedValues)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        toast.success("Succès d'ajout!");
        form.resetFields();
        navigateTo("/grossistes");
      } else {
          toast.error("Erreur pendant l'ajout!");
      }
    }
    );
  };

  const navigateTo = (path) => {
    history.push(path);
  };

  useEffect(() => {
    dispatch(getGovernments({ page: 1, limit: 10 }));
  }, [dispatch]);

  const onReset = () => {
    form.resetFields();
  };

  return (
    <div>
      <Card
        bordered
        className="criclebox tablespace mb-24"
        title="Ajouter un grossiste"
      />
      <Card bordered={false}>
        <Form {...layout} form={form} name="control-hooks" onFinish={onFinish}>
          <FormFields />
          <Form.Item {...tailLayout}>
            <Space size="small">
              <Button type="primary" htmlType="submit" loading={person_loading}>
                Enregistrer
              </Button>
              <Button htmlType="button" onClick={onReset}>
                Reset
              </Button>
              <Button
                type="link"
                htmlType="button"
                onClick={() => navigateTo("/grossistes")}
              >
                Annuler
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default AddGrossistesPage;
